
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-welfare/playground/details",
      function () {
        return require("private-next-pages/public-welfare/playground/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-welfare/playground/details"])
      });
    }
  